import { render, staticRenderFns } from "./InfoautoCustomersPage.vue?vue&type=template&id=5510ce2a&scoped=true"
import script from "./InfoautoCustomersPage.vue?vue&type=script&lang=js"
export * from "./InfoautoCustomersPage.vue?vue&type=script&lang=js"
import style0 from "./InfoautoCustomersPage.vue?vue&type=style&index=0&id=5510ce2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510ce2a",
  null
  
)

export default component.exports